import * as core from '../../../../../../../core'

import { query } from './functional-area-bar-chart.query'

export const RESOURCE = {
  payload: {
    alias: 'functional.area.bar.chart',
    description: 'Bar chart of change impacts by functional area',
    name: 'Functional Area Bar Chart',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
